export default function BackgroundLayer({ image }) {
  return (
    <>
      <div
        className="bg-image-layer"
        style={{ backgroundImage: image ? `url(${image})` : "none" }}
      />
      <div className="bg-overlay" />
    </>
  );
}
